<template>
  <!-- 诚信评价-新增情况 -->
  <div class="situation">
    <div class="accident" @click="showPop">
      <div class="tip">受处理类型</div>
      <div class="drop_down">
        <span v-if="!select.text">请选择</span>
        <span class="selected" v-if="select.text">{{select.text}}</span>
        <img src="@/assets/appraise/arrow_right.png" alt />
      </div>
    </div>
    <div class="upload_file">
      <div class="upload_tit">相关材料</div>
      <div class="file_item" v-for="(item,index) in files" :key="item.id">
        <div class="file_msg">
          <img src="@/assets/appraise/ic_pdf.png" alt />
          <p class="file_name">
            <span>{{item.fileName}}.{{item.fileType}}</span>
          </p>
        </div>
        <div class="delImg" @click="del(index)">
          <img src="@/assets/appraise/delete.png" alt />
        </div>
        <!-- <div class="file_size">{{item.fileSize}}</div> -->
      </div>
      <addBtn
        ref="resetfilesbtn"
        v-if=" files && files.length < 10"
        :isShowSpan="true"
        :isGoAndroidandIOS="true"
        :needEmit="true"
        @fields="getFiles"
      ></addBtn>
    </div>
    <div class="btns">
      <van-button @click="save" type="primary" size="large">保存</van-button>
    </div>

    <!-- </van-popup> -->
    <commonPicker
      ref="commonPickerCreditType"
      title="请选择受处理类型"
      :typeList="creditType"
      :cols="1"
      @getTypeValue="getTypeValue"
    ></commonPicker>

    <confirmDialog
      v-if="showDialog"
      :title="dialogTitle"
      :content="dialogContent"
      :cancelTxt="cancelBtn"
      :confirmTxt="confirmBtn"
      @confirm="confirm"
      @cancel="cancel"
    ></confirmDialog>

    <tipDialog
      v-if="isShowTipDialog"
      :content="tipDialogContent"
      @closeModal="isShowTipDialog = false"
    ></tipDialog>
  </div>
</template>

<script>
import API from "@/service/modules/appraiseNewWzy.js";
import confirmDialog from "../components/confirmDialog.vue";
import addBtn from "../appraiseNew/components/addBtn.vue";
import commonPicker from "../../../components/base/myCommonPicker.vue";
import tipDialog from "./components/tipDialog.vue";
import icon from "@/assets/appraise/icon_ts_gx@3x.png";
import commonAPI from "@/utils/common";
export default {
  components: {
    commonPicker,
    tipDialog,
    confirmDialog,
    addBtn,
  },
  data() {
    return {
      showDialog: false,
      dialogTitle: "类型",
      dialogContent: "",
      cancelBtn: "",
      confirmBtn: "",
      show: false,
      message: "",
      saveAndDel: "", // 保存还是删除
      id: "", // 详情 id
      detailQuery: {},
      /** 选择类型 **/
      creditType: [
        [
          { id: "C1", text: "诚信评价基础工作考评" },
          { id: "C2", text: "诚信评价完成率考评" },
          { id: "C3", text: "诚信评价质量考评" },
          { id: "C4", text: "诚信评价结果运用考评" },
        ],
      ],
      /** 选中的值 **/
      select: {
        id: "",
        text: "",
      },
      /** 文件 **/
      files: [],
      delIndex: {}, // 存放删除的索引
      isShowTipDialog: false, // 没有选择类型的提示
      tipDialogContent: "", // 提示文字
    };
  },
  created() {
    /** 获取参数 **/
    this.detailQuery = this.$route.query;
    /** 有参数就去请求详情 **/
    if (this.detailQuery.integrityType) {
      this.getDetails();
    }
  },
  methods: {
    /**
     * @description: 获取详情信息
     */
    async getDetails() {
      const res = await API.getIntegrityDetails(this.detailQuery);
      if (res.ret === 0) {
        this.id = res.data.id;
        this.select = {
          id: res.data.integrityType,
          text: res.data.integrityTypeCN,
        };
        this.files = res.data.fileResVOS ? res.data.fileResVOS : [];
      }
    },
    /**
     * @description: 受处理类型选择框
     */
    showPop() {
      // if ( this.detailQuery.integrityType ) {
      //     this.isShowTipDialog = true;
      //     this.tipDialogContent = '受处理类型不可编辑';
      //     return;
      // }
      this.$refs.commonPickerCreditType.showPicker();
    },
    /**
     * @description: 保存按钮，调起二次确认弹窗
     */
    save() {
      this.dialogTitle = "是否确定保存";
      this.dialogContent = "";
      this.cancelBtn = "取消";
      this.confirmBtn = "保存";
      this.showDialog = true;
      this.saveAndDel = "save"; // 保存还是删除
    },
    /**
     * @description: 删除，调起二次确认弹窗
     */
    del(index) {
      this.dialogTitle = "是否确定删除";
      this.dialogContent = "";
      this.cancelBtn = "取消";
      this.confirmBtn = "删除";
      this.showDialog = true;
      this.saveAndDel = "del"; // 保存还是删除
      this.delIndex = index;
      if (this.$refs.resetfilesbtn) {
        this.$refs.resetfilesbtn.resetFile();
      }
    },
    /** 上传文件 **/
    getFiles(file) {
      this.files.push(file[0]);
    },
    /**
     * @description: 保存 二次确认弹窗回调
     */
    confirm() {
      this.showDialog = false;
      const type = this.saveAndDel;
      switch (type) {
        case "save":
          this.confirmSave(); // 执行保存操作
          break;
        case "del":
          this.confirmDelFile(); // 执行删除操作
          break;
      }
    },
    /**
     * @description: 保存二次确认后执行
     */
    async confirmSave() {
      const _this = this;
      if (!this.select.id) {
        this.isShowTipDialog = true;
        this.tipDialogContent = "请选择受处理类型";
        return;
      }
      const data = {
        ...this.detailQuery,
        id: this.id || "",
        integrityType: this.select.id,
        fileResVOS: this.files,
      };
      const res = await API.integrityAddAndEdit(data);
      if (res.ret === 0 && res.data !== 100002) {
        this.$Toast({
          message: "保存成功",
          icon,
        });
        setTimeout(() => {
          this.$router.back(-1);
          const params = commonAPI.getJsonLocal("creditlistparams");
          if (params) {
            commonAPI.removeJsonLocal("creditlistparams");
          }
          commonAPI.setJsonLocal("creditlistparams", {
            area: _this.$route.query.area,
            integrityType: this.select.id,
            quarter: _this.$route.query.quarter,
            year: _this.$route.query.year,
            updateAuth: _this.$route.query.updateAuth,
            deleteAuth: _this.$route.query.deleteAuth,
            userAuthoirese: _this.$route.query.userAuthoirese,
          });
          //   this.$router.replace({
          //     path: "/appraise/creditDetail",
          //     query: {
          //       area: _this.$route.query.area,
          //       integrityType: this.select.id,
          //       quarter: _this.$route.query.quarter,
          //       year: _this.$route.query.year,
          //       updateAuth: _this.$route.query.updateAuth,
          //       deleteAuth: _this.$route.query.deleteAuth,
          //       userAuthoirese: _this.$route.query.userAuthoirese,
          //     },
          //   });
        }, 1000);
      } else if (res.ret === 0 && res.data === 100002) {
        // 新增时，如果类型已存在，显示提示窗
        this.isShowTipDialog = true;
        this.tipDialogContent = "类型已存在，不可重复增加";
      }
    },
    /**
     * @description: 删除附件二次确认后执行
     */
    async confirmDelFile() {
      this.files.splice(this.delIndex, 1);
    },
    /**
     * @description: 受处理类型确认按钮的回调
     */
    getTypeValue(e) {
      this.select = e[0];
    },
    // 弹窗失败回调
    cancel() {
      this.showDialog = false;
    },
  },
};
</script>

<style scoped lang="less">
.situation {
  // padding: 9px 12px 0;
  height: 100%;
  background-color: #fbfbfb;
}
.unclick {
  pointer-events: none;
  color: #ccc;
}
.accident {
  display: flex;
  justify-content: space-between;
  padding: 16px 12px 0;
  height: 46px;
  border-bottom: 1px solid #ededed;
  background-color: #fff;
  .tip {
    color: #666;
    font-size: 14px;
  }
  .input input {
    text-align: right;
  }
  .input input::-webkit-input-placeholder {
    font-size: 14px;
    color: #ccc;
    text-align: right;
  }
  .drop_down {
    span {
      margin-right: 4px;
      color: #ccc;
      font-size: 14px;
    }
    span.selected {
      color: #333;
      font-size: 14px;
    }
    img {
      display: inline-block;
      width: 12px;
      height: 12px;
      vertical-align: text-top;
    }
  }
}
.btns {
  padding: 16px 12px;
  height: 60px;
  // background:rgba(255,255,255,1);
  // box-shadow:0px -2px 8px 0px rgba(0,0,0,0.03);
  .van-button {
    width: 351px;
    height: 40px;
    background-color: #36b374;
  }
}
.upload_file {
  padding: 0 12px 16px;
  background-color: #fff;
  .upload_tit {
    padding: 16px 0;
    font-size: 14px;
    color: #666;
  }
}
.file_item {
  display: flex;
  box-sizing: border-box;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 15px;
  .file_msg {
    flex: 1;
    display: flex;
    align-items: center;
  }
  .file_msg img {
    margin-right: 12px;
    width: 34px;
    height: 38px;
  }
  .file_msg p {
    font-size: 14px;
    color: #333;
    span {
      line-height: 20px;
      word-break: break-word;
    }
  }
  .file_size {
    font-size: 12px;
    color: #999;
  }
  .delImg {
    box-sizing: border-box;
    line-height: 38px;
    margin-left: 5px;
    margin-right: 10px;
  }
  .delImg img {
    width: 15px;
    height: 16px;
  }
}
</style>
